export const itemTypeValues = ['book', 'section', 'part', 'chapter', 'volume', 'subject'];
//# sourceMappingURL=types.js.map